import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";

const TOPICS = ["Ayurveda education", "Therapies", "Herbs & ingredients", "Kerala Ayurveda travel", "Research updates"];

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [topics, setTopics] = useState(["Ayurveda education"]);
  const [busy, setBusy] = useState(false);

  const toggle = (t) => setTopics((p) => (p.includes(t) ? p.filter((x) => x !== t) : [...p, t]));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/newsletter/subscribe", { email, topics });
      toast.success(res.data.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="relative overflow-hidden rounded-3xl bg-brand px-6 py-14 sm:px-14 sm:py-16">
        <div className="noise-overlay absolute inset-0" />
        <div className="relative grid gap-10 md:grid-cols-2 md:items-center">
          <div>
            <h2 className="font-heading text-3xl sm:text-4xl text-brand-sand leading-tight">
              Seasonal Ayurveda, in your inbox
            </h2>
            <p className="mt-4 max-w-md text-brand-sand/75">
              Join our newsletter for reviewed articles, herb guides and seasonal routines. Choose only
              the topics you care about — consent is respected and separate for each.
            </p>
          </div>
          <form onSubmit={submit} className="space-y-4">
            <div className="flex flex-wrap gap-2">
              {TOPICS.map((t) => (
                <button
                  type="button"
                  key={t}
                  data-testid={`topic-${t}`}
                  onClick={() => toggle(t)}
                  className={`rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${
                    topics.includes(t)
                      ? "border-brand-sand bg-brand-sand text-brand"
                      : "border-brand-sand/30 text-brand-sand/80 hover:border-brand-sand/70"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
            <div className="flex gap-2">
              <input
                data-testid="newsletter-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="flex-1 rounded-full border border-brand-sand/30 bg-white/10 px-5 py-3 text-brand-sand placeholder:text-brand-sand/50 outline-none focus:border-brand-sand"
              />
              <button
                data-testid="newsletter-submit"
                disabled={busy}
                className="flex items-center gap-2 rounded-full bg-brand-clay px-5 py-3 font-medium text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
              >
                <Send className="h-4 w-4" /> Subscribe
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
